import React from 'react';
import {Switch,Route,useRouteMatch,Link} from 'react-router-dom'
import SettingList from './settingList';
import styles from './setting.module.css'
import Profileset from './profileset';
import Privacyset from './privacyset';
import NotificationSet from './notificationset';
import EditProfile from '../editProfile/editProfile';
import {BiArrowBack} from 'react-icons/bi'
const Setting=()=>{

    const { path } = useRouteMatch()


    return(
        <div className={styles.container}>
            <Switch>
            <Route exact path="/setting">
           <SettingList/>
            </Route>
            <Route path={`/setting/profile`}>
            
            <Profileset/>
            </Route>
            <Route path={`/setting/privacy`}>
             <Privacyset/>
            </Route>
            <Route path={`/setting/notification`}>
          <NotificationSet/>
            </Route>
            <Route path={`/setting/edit-profile`}>
            <div  className={styles.backbtn} >
            <Link to="/setting">
           <BiArrowBack/>
         </Link>
         </div>
          <EditProfile/>
            </Route>
            <Route path={`/setting/message`}>
           <h1>hello from profile</h1>
            </Route>
            <Route path={`/setting/activity`}>
           <h1>hello from profile</h1>
            </Route>
            <Route path={`/setting/language`}>
           <h1>hello from profile</h1>
            </Route>

            </Switch>



            </div>
    )
}

export default Setting;